<template>
<section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
            <el-form-item>
                <el-input v-model="filters.likeCardKey" placeholder="输卡号/ICCID/IMSI"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="filters.remark" placeholder="请输入备注信息"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" v-on:click="getCards">查询</el-button>
                <el-button type="primary" v-on:click="exportExcel">导出</el-button>
            </el-form-item>
        </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="cards" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
        <el-table-column prop="msisdn" label="卡号" sortable>
        </el-table-column>
        <el-table-column prop="iccid" label="ICCID" sortable>
        </el-table-column>
        <el-table-column prop="imsi" label="IMSI" sortable>
        </el-table-column>
        <el-table-column prop="remark" label="备注信息" sortable>
        </el-table-column>
        <el-table-column label="操作" width="300" fixed="right">
            <template scope="scope" v-if="sysUserName!=null">
                <template v-if="sysUserName=='管理员' || sysUserName=='一级服务商'">
                    <el-button size="small" @click="updateCard(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="small" @click="handleMore(scope.$index, scope.row)">详细</el-button>
                    <el-button size="small" @click="showQrcode(scope.$index, scope.row)">二维码</el-button>
                    <el-button size="small" @click="handleSmsMgr(scope.$index, scope.row)">短信</el-button>
                </template>
                <template v-else>
                    <el-button size="small" @click="handleMore(scope.$index, scope.row)">详细</el-button>
                    <el-button size="small" @click="showQrcode(scope.$index, scope.row)">二维码</el-button>
                    <el-button size="small" @click="handleSmsMgr(scope.$index, scope.row)">短信</el-button>
                </template>
            </template>
        </el-table-column>
    </el-table>

    <!--工具条(分页)-->
    <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
    </el-col>

    <el-dialog title="短信管理" :visible.sync="smsMgrVisible" :close-on-click-modal="false" size="small">
        <iframe :src="smsMgrUrl" width="100%" height="600" frameborder="0"></iframe>
    </el-dialog>

    <!--卡号信息详情界面-->
    <cardinfo ref="cardinfo"></cardinfo>
    <cardqrcode ref="cardqrcode"></cardqrcode>

    <!--编辑界面-->
    <el-dialog title="编辑卡号" :visible.sync="updateformStatus" :close-on-click-modal="true">
        <el-form :model="editCard" ref="editCard" :rules='editRules' label-width="100px" class="demo-ruleForm">
            <el-form-item label="卡号" prop="msisdn">
                <el-input v-model="editCard.msisdn" readonly="readonly" disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="备注信息" prop="remark">
                <el-input v-model="editCard.remark"></el-input>
            </el-form-item>
            <el-form-item label="到期时间" prop="expiretime">
                <el-date-picker v-model="editCard.expiretime" type="date" style="width:100%" placeholder="到期时间" :disabled="disabledEditCardExpiretimeAuth">
                </el-date-picker>
            </el-form-item>

        </el-form>
        <div slot="footer" style="text-align:right" class="dialog-footer">
            <el-button @click="closeedit()">取消</el-button>
            <el-button type="primary" @click.native="editCardAction('editCard')">保存</el-button>
        </div>
    </el-dialog>
</section>
</template>

<script>
import util from '../../common/js/util'
import constant from '../../common/js/constant'
//import NProgress from 'nprogress'
import {
    getCardByRemark,
    batchEditCard,
    getChildUsers,
    getAllPackList,
    getAppsynList,
    getCardDetail,
    updateCardRemarkAndDate
} from '../../api/api';
import Cardinfo from '../../components/card_info.vue';
import CardQrcode from '../../components/card_qrcode.vue';
import BatchActive from '../../components/batch_active.vue';

export default {
    components: {
        cardinfo: Cardinfo,
        cardqrcode: CardQrcode,
        batchactive: BatchActive
    },
    data() {
        return {
            sysUserName: '',
            pickerOptions0: {
                disabledDate(time) {
                    return false;
                }
            },
            options_cardstate: constant.opt_cardstate,
            options_cardtype: constant.opt_cardtype,
            options_cardapicode: constant.opt_cardapicode,
            options_servicerman: constant.opt_servicerman,
            options_servicerLevel: [],
            filters: {
                //模糊查询卡关键字
                likeCardKey: '',
                remark: ''
            },
            cards: [],
            total: 0, //列表总条数
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            listLoading: false,
            sels: [], //列表选中列

            editFormVisible: false, //批量编辑界面是否显示
            editLoading: false,
            editFormRules: {
                cardnoBt: [{
                        required: true,
                        message: '请输入最小MSISDN',
                        trigger: 'blur'
                    },
                    {
                        min: 11,
                        max: 13,
                        message: '长度在 11 到 13 个字符',
                        trigger: 'blur'
                    }
                ],
                cardnoEt: [{
                        required: true,
                        message: '请输入最大MSISDN',
                        trigger: 'blur'
                    },
                    {
                        min: 11,
                        max: 13,
                        message: '长度在 11 到 13 个字符',
                        trigger: 'blur'
                    }
                ]
            },
            //批量编辑界面数据
            editForm: {
                cardnoBt: '',
                cardnoEt: '',
                packagenameChecked: false,
                packagename: '',
                apiChecked: false,
                servicerapi: '',
                servicemanChecked: false,
                serviceman: '',
                packagenameUse: true,
                servicerapiUse: true,
                servicemanUse: true
            },
            updateformStatus: false,
            //编辑界面数据
            editCard: {
                msisdn: "",
                remark: "",
                expiretime: ''
            },
            disabledEditCardExpiretimeAuth: true,
            editRules: {
                remark: [{
                    max: 50,
                    message: '备注信息长度不能超过50',
                    trigger: 'blur'
                }]
            },
            smsMgrVisible: false,
            smsMgrUrl: ""

        }
    },
    methods: {
        //性别显示转换
        formatSex: function (row, column) {
            return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
        },
        selsChange: function (sels) {
            this.sels = sels;
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getCards();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getCards();
        },
        //获取卡号列表
        getCards() {
            let para = {
                pageSize: this.pageSize,
                pageNum: this.currentPage,
                msisdn: this.filters.likeCardKey.trim(),
                remark: this.filters.remark.trim()
            };
            if(""==this.filters.remark.trim() && ""==this.filters.likeCardKey.trim()){
                this.$message({
                    message: "查询条件必须输入卡号或者备注信息",
                    type: 'error'
                });
                return;
            }
            this.listLoading = true;
            //NProgress.start();
            getCardByRemark(para).then((res) => {
                this.total = res.data.total;
                this.cards = res.data.list;
                this.listLoading = false;
                //NProgress.done();
            });
        },
        //显示短信管理界面
        handleSmsMgr: function (index, row) {
            //this.$refs.cardinfo.showCardDetail(row.msisdn);
            this.smsMgrVisible = true;
            this.smsMgrUrl = "http://www.yunkawulian.com:89/sim/?cardnumber=" + row.msisdn;
            //this.smsMgrUrl="http://www.yunkawulian.com:8080/sms/wechat/sendmessage?cardNo="+row.msisdn;
        },
        exportExcel() {
            let para = "";
            para += "msisdn=" + this.filters.likeCardKey.trim();
            para += "&remark=" + this.filters.remark.trim();
            if(""==this.filters.remark.trim() && ""==this.filters.likeCardKey.trim()){
                this.$message({
                    message: "查询条件必须输入卡号或者备注信息",
                    type: 'error'
                });
                return;
            }
            location.href = "/api/cards/exportLikeRemarkCardsXls?" + para;
        },
        //显示卡号详细界面
        handleMore: function (index, row) {
            this.$refs.cardinfo.showCardDetail(row.msisdn);
        },
        //显示二维码界面
        showQrcode: function (index, row) {
            let price = parseFloat(row.rechargePrice);
            if (price <= 0) {
                this.$message({
                    message: "请先设置该物联网卡的充值价格！",
                    type: 'error'
                });
                return;
            } else {
                this.$refs.cardqrcode.showCardQrcode(row.iccid);
            }

        },
        changePackagenameChecked: function (val) {
            if (val) {
                this.editForm.packagenameUse = false;
                this.editForm.packagename = "";
            } else {
                this.editForm.packagenameUse = true;
                this.editForm.packagename = "";
            }
        },
        changeApiChecked: function (val) {
            if (val) {
                this.editForm.servicerapiUse = false;
                this.editForm.servicerapi = "";
            } else {
                this.editForm.servicerapiUse = true;
                this.editForm.servicerapi = "";
            }
        },
        changeServicemanChecked: function (val) {
            if (val) {
                this.editForm.servicemanUse = false;
                this.editForm.serviceman = "";
            } else {
                this.editForm.servicemanUse = true;
                this.editForm.serviceman = "";
            }
        },
        //单个编辑界面
        updateCard: function (index, row) {
            let para = {
                cardId: row.msisdn
            };
            this.updateformStatus = true;
            getCardDetail(para).then((res) => {
                this.editCard.remark = res.data.remark;
                this.editCard.msisdn = res.data.msisdn;
                this.editCard.expiretime = res.data.expiretime;
            });

        },
        //关闭编辑
        closeedit() {
            this.updateformStatus = false;
        },
        editCardAction(editCard) {
            this.$refs[editCard].validate((valid) => {
                if (valid) {
                    let param = this.editCard;
                    this.editCard.expiretime = (!this.editCard.expiretime || this.editCard.expiretime == '') ? '' : util.formatDate.format(new Date(this.editCard.expiretime), 'yyyy-MM-dd');
                    param.expiretime == this.editCard.expiretime;

                    updateCardRemarkAndDate(param).then((res) => {
                        if (res.code === 0) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                            });
                            this.updateformStatus = false;
                            this.getCards();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'warning',
                            });
                        }
                    });
                }
            });
        },

    },
    mounted() {
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            if (user.userlevel == 0) {
                this.sysUserName = '管理员';
                this.disabledEditCardExpiretimeAuth = false;
                this.options_servicerLevel = [{
                        "label": "管理员",
                        "value": "0"
                    },
                    {
                        "label": "一级服务商",
                        "value": "1"
                    },
                    {
                        "label": "二级服务商",
                        "value": "2"
                    }
                ];
            } else if (user.userlevel == 1) {
                this.sysUserName = '一级服务商';
                this.options_servicerLevel = [{
                        "label": "一级服务商",
                        "value": "1"
                    },
                    {
                        "label": "二级服务商",
                        "value": "2"
                    }
                ];
            } else if (user.userlevel == 2) {
                this.sysUserName = '二级服务商';
                this.options_servicerLevel = [{
                    "label": "二级服务商",
                    "value": "2"
                }];
            }
        }

        let para = {};
        getAllPackList(para).then((res) => {
            this.editLoading = false;
            this.options_cardtype = res.data;
        });
        getChildUsers(para).then((res) => {
            this.editLoading = false;
            this.options_servicerman = res.data;
        });

        //this.getCards();
    }
}
</script>



// WEBPACK FOOTER //
// remark_query.vue?406e7bf8